const BankAccountGetter = {
    bankAccounts: (state) => state.bankAccounts,
    banks: state => state.banks
};

export default BankAccountGetter;